import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as Diff from 'diff';

@Pipe({
  name: 'diff',
  standalone: true
})
export class DiffPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(updated: string | undefined, original: string): SafeHtml {
    if (updated === undefined || updated === null || updated === original) {
        return original; // No diff needed
    }

    const diff = Diff.diffWords(original, updated);
    let html = '';

    diff.forEach(part => {
        // Encode HTML entities in content to prevent injection, then wrap
        const esc = this.escapeHtml(part.value);
        if (part.added) {
            html += `<span class="diff-add" style="background-color: #e6ffed; color: #2e7d32; text-decoration: none;">${esc}</span>`;
        } else if (part.removed) {
            html += `<span class="diff-rem" style="background-color: #ffeef0; color: #b31d28; text-decoration: line-through;">${esc}</span>`;
        } else {
            html += esc;
        }
    });

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  private escapeHtml(text: string): string {
      const map: {[key: string]: string} = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      };
      return text.replace(/[&<>"']/g, (m) => map[m]);
  }
}
